
const CHICAGO_TIME_ZONE = "America/Chicago";
const ISO_WITHOUT_TIMEZONE_REGEX = /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?)?$/;
const HAS_TIMEZONE_SUFFIX_REGEX = /(Z|[+-]\d{2}:?\d{2})$/i;

const getTimeZoneOffsetMs = (date, timeZone) => {
    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
    });

    const parts = formatter.formatToParts(date);
    const values = {};
    for (const part of parts) {
        if (part.type !== "literal") {
            values[part.type] = part.value;
        }
    }

    const asUtc = Date.UTC(
        Number(values.year),
        Number(values.month) - 1,
        Number(values.day),
        Number(values.hour),
        Number(values.minute),
        Number(values.second)
    );

    return asUtc - date.getTime();
};

const chicagoWallTimeToLocalDate = ({ year, month, day, hour, minute, second, millisecond }) => {
    const utcFromWallTime = Date.UTC(year, month - 1, day, hour, minute, second, millisecond);
    const initialOffset = getTimeZoneOffsetMs(new Date(utcFromWallTime), CHICAGO_TIME_ZONE);
    let adjustedTimestamp = utcFromWallTime - initialOffset;
    const correctedOffset = getTimeZoneOffsetMs(new Date(adjustedTimestamp), CHICAGO_TIME_ZONE);

    if (correctedOffset !== initialOffset) {
        adjustedTimestamp = utcFromWallTime - correctedOffset;
    }

    return new Date(adjustedTimestamp);
};

const parseDjangoDateToLocal = (dateString) => {
    if (dateString === null || dateString === undefined) {
        return new Date(NaN);
    }

    const raw = String(dateString).trim();
    if (!raw) {
        return new Date(NaN);
    }

    if (HAS_TIMEZONE_SUFFIX_REGEX.test(raw)) {
        return new Date(raw);
    }

    const match = raw.match(ISO_WITHOUT_TIMEZONE_REGEX);
    if (!match) {
        return new Date(raw);
    }

    const [
        ,
        yearRaw,
        monthRaw,
        dayRaw,
        hourRaw = "00",
        minuteRaw = "00",
        secondRaw = "00",
        millisecondRaw = "0",
    ] = match;

    return chicagoWallTimeToLocalDate({
        year: Number(yearRaw),
        month: Number(monthRaw),
        day: Number(dayRaw),
        hour: Number(hourRaw),
        minute: Number(minuteRaw),
        second: Number(secondRaw),
        millisecond: Number(millisecondRaw.padEnd(3, "0")),
    });
};

export function formatDjangoDate(dateString) {
    const date = parseDjangoDateToLocal(dateString);
    if (isNaN(date)) return dateString;
    return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export function formatDjangoDateTime(dateString) {
    const date = parseDjangoDateToLocal(dateString);
    if (isNaN(date)) return dateString;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const timezone =
        new Intl.DateTimeFormat(undefined, { timeZoneName: "short" })
            .formatToParts(date)
            .find((part) => part.type === "timeZoneName")?.value || "UTC";

    return `${year}-${month}-${day} ${hours}:${minutes} ${timezone}`;
}
